{
  "name": "mental",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "packageManager": "pnpm@12.5.1+sha512.e3f305bc784a2bc89f5ad3b6138889470fae8d2af5f36b61216ec91c2c3d64089775f9de38aac331044ea40f245cb0d5666392dfdf65824e1907ef6a2c62de5f",
  "scripts": {
    "dev": "vite",
    "generate:api": "wait-on http://127.0.0.1:8000/api/schema && orval --config orval.config.ts",
    "build": "vite build",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "type-check": "tsc --noEmit",
    "test": "vitest run",
    "test:watch": "vitest --project unit",
    "test:ui": "vitest --project unit --ui",
    "test:storybook": "vitest run --project storybook",
    "coverage": "vitest run --coverage",
    "preview": "vite preview",
    "storybook": "storybook dev -p 6006 --no-open",
    "build-storybook": "storybook build",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:prod": "playwright test -c playwright.prod.config.ts"
  },
  "dependencies": {
    "@amcharts/amcharts4": "^4.10.40",
    "@amcharts/amcharts4-geodata": "^4.1.32",
    "@base-ui/react": "^1.7.0",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/modifiers": "^9.0.0",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@faker-js/faker": "^10.6.0",
    "@hookform/resolvers": "^5.9.1",
    "@svg-maps/south-korea": "^2.0.0",
    "@tabler/icons-react": "^3.46.0",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/react-query": "^5.102.4",
    "@tanstack/react-query-devtools": "^5.102.4",
    "@tanstack/react-table": "^8.21.3",
    "@types/highcharts": "^7.0.0",
    "axios": "^1.19.0",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "d3": "^7.9.0",
    "date-fns": "^4.4.0",
    "embla-carousel-react": "^8.6.0",
    "highcharts": "^12.6.0",
    "highcharts-react-official": "^3.2.3",
    "highcharts-wordcloud": "^0.1.7",
    "lucide-react": "^0.556.0",
    "motion": "^13.3.0",
    "msw": "^2.15.0",
    "next-themes": "^0.4.6",
    "react": "^19.2.8",
    "react-day-picker": "^9.14.0",
    "react-dom": "^19.2.8",
    "react-hook-form": "^7.86.0",
    "react-kakao-maps-sdk": "^1.2.2",
    "react-player": "^3.4.0",
    "react-resizable-panels": "^3.0.6",
    "react-router-dom": "^7.18.2",
    "react-spinners": "^0.17.0",
    "recharts": "2.15.4",
    "sonner": "^2.0.8",
    "tailwind-merge": "^3.6.0",
    "tailwindcss-animate": "^1.0.7",
    "vaul": "^1.1.2",
    "vite-plugin-svgr": "^5.2.0",
    "wait-on": "^9.1.0",
    "zod": "^4.4.3",
    "zustand": "^5.0.15"
  },
  "devDependencies": {
    "@chromatic-com/storybook": "^5.3.1",
    "@eslint/css": "^0.14.1",
    "@eslint/js": "^9.39.5",
    "@playwright/test": "^1.62.1",
    "@storybook/addon-a11y": "^10.6.0",
    "@storybook/addon-docs": "^10.6.0",
    "@storybook/addon-mcp": "^10.6.0",
    "@storybook/addon-vitest": "^10.6.0",
    "@storybook/react-vite": "^10.6.0",
    "@testing-library/jest-dom": "^6.10.0",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.6",
    "@types/d3": "^7.4.3",
    "@types/node": "^24.13.3",
    "@types/react": "^19.2.18",
    "@types/react-dom": "^19.2.5",
    "@vitejs/plugin-react": "^6.1.0",
    "@vitest/browser-playwright": "^4.1.11",
    "@vitest/coverage-v8": "^4.1.11",
    "@vitest/ui": "^4.1.11",
    "autoprefixer": "^10.5.4",
    "code-inspector-plugin": "^2.0.9",
    "eslint": "^10.10.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-boundaries": "^7.3.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-mindcast": "workspace:*",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.4.26",
    "eslint-plugin-storybook": "^10.6.0",
    "globals": "^16.5.0",
    "jsdom": "^29.1.1",
    "msw-storybook-addon": "^3.0.0",
    "orval": "^8.26.0",
    "playwright": "^1.62.1",
    "postcss": "^8.5.26",
    "prettier": "3.7.4",
    "prettier-plugin-tailwindcss": "^0.7.4",
    "sass-embedded": "^1.103.1",
    "storybook": "^10.6.0",
    "tailwindcss": "^4.3.3",
    "tw-animate-css": "^1.4.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.68.0",
    "vite": "^8.2.2",
    "vite-css-modules": "^1.16.0",
    "vite-plugin-devtools-json": "^1.1.0",
    "vitest": "^4.1.11"
  },
  "msw": {
    "workerDirectory": [
      "public"
    ]
  }
}
